import { createElement } from '../../core/dom/helpers.js';

/**
 * Pure DOM render for a list of selected-value chips with remove buttons.
 * Strictly text-based: `chip.textContent = label`, `aria-label="Remove {label}"`.
 * NO innerHTML, NO template-string DOM construction. Empty container before
 * render (no orphans). Used by `searchable-multi-engine`, `chips-engine`, and
 * the async `multiselect` filter driver.
 *
 * @param {HTMLElement} container
 * @param {{
 *   values: string[],
 *   labels: Map<string, string>,
 *   classes: { chip: string, removeBtn: string },
 *   onRemove: (id: string) => void,
 *   disabled: boolean,
 * }} cfg
 */
export function renderChips(container, cfg) {
  const { values, labels, classes, onRemove, disabled } = cfg;
  const ownerDocument = container.ownerDocument;
  container.textContent = '';
  for (const id of values) {
    const label = labels.get(id) ?? `#${id}`;
    const chip = createElement('span', { class: classes.chip });
    chip.appendChild(ownerDocument.createTextNode(label));
    const removeBtn = /** @type {HTMLButtonElement} */ (createElement('button', {
      type: 'button',
      class: classes.removeBtn,
      'aria-label': `Remove ${label}`,
    }));
    removeBtn.textContent = '×';
    removeBtn.disabled = disabled;
    removeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (disabled) return;
      onRemove(id);
    });
    chip.appendChild(removeBtn);
    container.appendChild(chip);
  }
}
